// @flow
/** @jsx h */
import './polyfills'
import domready from 'domready'
import { h, render } from 'preact'
import { LivePollWidget } from '../../../shared/widgets/LivePoll/LivePollWidget'
import { init } from '../../init'
import { enableDevtools } from '../../utils/devtools'

const rootElementClassName = 'dh-stemning-root' // import en css-modul her og på serveren - så slipper vi å hardkode
window[rootElementClassName] = window[rootElementClassName] || {}

function mountFn (el) {
  const preloadedState = JSON.parse(decodeURIComponent(el.dataset.preloadedState))
  const { clientId, theme, authConfig, showResult, resultMessage } = preloadedState
  const AppComponent = (
    <LivePollWidget
      clientId={clientId}
      authConfig={authConfig}
      theme={theme}
      showResult={showResult}
      resultMessage={resultMessage}
    />
  )
  render(AppComponent, el, el.firstChild)
}

domready(() => init(rootElementClassName, mountFn, enableDevtools))



// WEBPACK FOOTER //
// ./src/client/widgets/livepoll/index.js